module.exports = {
  N: 'n',
  D1: 'd1',
  D2: 'd2',
  D3: 'd3',
  D4: 'd4',
  D5: 'd5',
  D6: 'd6',
  D7: 'd7',
  D8: 'd8',
  D2P: 'd2p',
  D9: 'd9',
  R: 'r',
  R2: 'r2',
  P: 'p',
  DISENGAGED: 'disengaged',
  SNA: 'sna',
};
